import { ActionTree } from 'vuex'
import { PointOfInterest } from './types'
import { RootState } from '../types'
import { PointsHelpers } from '@/helpers/mainExports.js'
import { i18n } from '@leapsight/portal'

export const actions: ActionTree<PointOfInterest, RootState> = {
  async getPointsList({ commit }) {
    try {
      const points = await PointsHelpers.getPoints()
      commit('setPointsOfInterest', points)
    } catch (error) {
      console.log(error)
    }
  },
  deletePoint({ dispatch, commit }, pointId) {
    PointsHelpers.deletePoint(pointId)
      .then(() => {
        dispatch('setResponseError', false)
        commit('deletePoint', pointId)
      })
      .catch(() => {
        dispatch('setResponseError', true)
        const response = i18n.t(
          'fleet_management.points_of_interest.data_table.errors.no_info'
        )
        dispatch('setResponseMessage', response)
      })
  },
  setResponseError({ commit }, payload) {
    commit('setResponseError', payload)
  },
  setResponseMessage({ commit }, message) {
    commit('setResponseMessage', message)
  },
}